import { render, staticRenderFns } from "./JoinRedirect.vue?vue&type=template&id=4f11bfec&scoped=true&"
import script from "./JoinRedirect.vue?vue&type=script&lang=js&"
export * from "./JoinRedirect.vue?vue&type=script&lang=js&"
import style0 from "./JoinRedirect.vue?vue&type=style&index=0&id=4f11bfec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f11bfec",
  null
  
)

export default component.exports